/**
 * Batch Status Badge Component
 * Displays batch status with color coding
 *
 * @author SAUBHAGYA Development Team
 * @since US-BATCH-001
 */

import { Badge } from '@/components/ui/badge';
import { InventoryBatchStatus, BatchStatusConfig } from '@/types/inventory';
import { cn } from '@/lib/utils';

interface BatchStatusBadgeProps {
  status: InventoryBatchStatus;
  className?: string;
}

export function BatchStatusBadge({ status, className }: BatchStatusBadgeProps) {
  // Get config with fallback for undefined or missing statuses
  const config = BatchStatusConfig[status] || {
    icon: '📦',
    label: status || 'Unknown Status',
    bgColor: 'bg-gray-100',
    color: 'text-gray-700'
  };

  return (
    <Badge
      className={cn(
        'font-medium',
        config.bgColor,
        config.color,
        'border-none',
        className
      )}
    >
      <span className="mr-1">{config.icon}</span>
      {config.label}
    </Badge>
  );
}
